import { render, staticRenderFns } from "./PancakeToken.vue?vue&type=template&id=0663d89f"
import script from "./PancakeToken.vue?vue&type=script&lang=js"
export * from "./PancakeToken.vue?vue&type=script&lang=js"
import style0 from "./PancakeToken.vue?vue&type=style&index=0&id=0663d89f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports